import { CSSProperties } from "@material-ui/core/styles/withStyles";

// ~-~-~-~-~-~-~-~-~-~-~-
// SuggestionsHome
// ~-~-~-~-~-~-~-~-~-~-~-
export const container: CSSProperties = {
  zIndex: 2,
  position: "relative",
  paddingBottom: 70,
};
